export default __webpack_public_path__ + "static/media/237.14ac9fb0.png";